import React, { useState, useEffect, useRef } from 'react';
import ProtectedRoute from '../../routes/protected';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import employeeService from '../../services/data/employee.service';
import FeedbackReceivedList from '../../components/performance/feedbackReceivedList';

export default function FeedbackReceived() {
    const toast = useRef(null);
    const navigate = useNavigate();
    const [myEmployeeId, setMyEmployeeId] = useState(null);

    useEffect(() => {
        employeeService.getUserEmployee().then((emp) => setMyEmployeeId(emp.id)).catch(() => {});
    }, []);

    function goBack() {
        navigate(myEmployeeId ? `/career/feedback/${myEmployeeId}/` : -1);
    }

    return (
        <ProtectedRoute>
            <Toast ref={toast} position="top-right" />

            <div className="container-fluid py-4">
                <div className="d-flex align-items-center gap-3 mb-4">
                    <button className="btn btn-link p-0 text-decoration-none text-muted" onClick={goBack}>
                        <FontAwesomeIcon icon={solid('arrow-left')} />
                    </button>
                    <div>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={solid('inbox')} className="me-2 text-primary" />
                            Feedbacks Recebidos
                        </h4>
                        <p className="text-muted small mb-0">Todos os feedbacks que você recebeu</p>
                    </div>
                </div>

                <FeedbackReceivedList onRequest={() => navigate('/feedback/request/')} />
            </div>
        </ProtectedRoute>
    );
}
